import { WarningAmber } from '@mui/icons-material'
import { Divider, Grid, Tooltip, Typography } from '@mui/material'

import { DeviceTableRow } from '../../routes/accounts/components/devices-tab-panel/types'
import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

const DeviceRow = ({ device }: { device: DeviceTableRow | IDeviceAPIObject }) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const isPaused = device.deviceStatus === 'Paused'

  return (
    <>
      <Grid container={true} sx={[sharedClasses.centerContentVertical, { gap: 2 }]}>
        <Typography
          variant="body2"
          sx={{
            my: 1,
            ...classes.deviceRowItem,
            fontStyle: isPaused ? 'italic' : 'normal',
            color: isPaused ? 'text.secondary' : 'text.primary',
          }}
        >
          {device.vanity} • {device.uniqueId} • {device.nodeType.vanityName}
        </Typography>

        {isPaused && (
          <Tooltip title="Device is currently paused">
            <WarningAmber sx={{ color: 'warning.light' }} />
          </Tooltip>
        )}
      </Grid>
      <Divider />
    </>
  )
}

export default DeviceRow
